

import React, { Component, Fragment } from "react";

export type DialogProvider_Props = {
  children: any;
};

export type DialogProvider_State = {};

class DialogProvider extends Component<DialogProvider_Props, DialogProvider_State> {
  render() {
    return (
      <Fragment>
        {this.props.children}
        <div id="modal-root" style={{
          zIndex: 999,
          position: 'absolute'
        }} />
      </Fragment>
    )
  }
}

export default DialogProvider;